export default {
  TITLE: {
    SET: 'TITLE/SET',
    GET: 'TITLE/GET',
    DELETE: 'TITLE/DELETE'
  }
}
